<template>
    <div class="w-full" style="background-color: #F4F4F4">
        <div class="py-20">
            <div class="max-w-7xl mx-auto">
                <div class="mx-16 2xl:mx-0">
                    <div class="w-full h-full pb-20">
                        <div class="flex mb-10 pt-10">
                            <h1 class="text-3xl">
                                Overnatting
                            </h1>
                        </div>
                        <div class="w-full h-full">
                            <div class="w-full h-full flex flex-col justify-center items-center">
                                <svg width="39" height="30" viewBox="0 0 39 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.5 17H25.5H13.5ZM19.5 11V23V11ZM1.5 25V5C1.5 3.93913 1.92143 2.92172 2.67157 2.17157C3.42172 1.42143 4.43913 1 5.5 1H17.5L21.5 5H33.5C34.5609 5 35.5783 5.42143 36.3284 6.17157C37.0786 6.92172 37.5 7.93913 37.5 9V25C37.5 26.0609 37.0786 27.0783 36.3284 27.8284C35.5783 28.5786 34.5609 29 33.5 29H5.5C4.43913 29 3.42172 28.5786 2.67157 27.8284C1.92143 27.0783 1.5 26.0609 1.5 25Z" stroke="#8E87C7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <p class="mt-6 font-semibold">Add accommodation</p>
                                <p class="text-gray-600">Get Started by choosing accommodation</p>
                                <button
                                    @click="showModal = true"
                                    type="button"
                                    class="mt-10 bg-primary-dark text-white rounded-md py-2 px-4 border border-font hover:bg-primary"
                                >
                                    + Choose from list
                                </button>
                            </div>
                            <div class="w-full rounded-lg grid grid-cols-2 gap-x-4 gap-y-4">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Modal
        :show="showModal"
        title="Endre aktivitet"
        @close="showModal = false"
    >
        <EditActivity
            v-for="data in editData"
            :img='data.img'
            :alt="data.alt"
            :title='data.title'
            :date='data.date'
            :dest='data.dest'
            :text='data.text'
            :price='data.price'
        />
    </Modal>
</template>

<script setup>
import { ref } from 'vue'
import EditActivity from "@/ComponentsDeprecated/Modal/EditActivity"
import Modal from "@/ComponentsDeprecated/Modal/EditActivityModal";

const showModal = ref(false)

const editData = [
    {
        title: "Grotteutflukt under Nice",
        date: "Tor 12. oktober kl. 10:30",
        dest: "Nice, france",
        text: "Ikke gå glipp av den unike muligheten til å oppleve en av de mange grottene under byen. Dette en flott introduksjon til den spennende sporten grotting.",
        price: "",
        img: "https://images.unsplash.com/photo-1550992402-9b1fc58fd76d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTZ8fGNhdmV8ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=900&q=60",
        alt: "Caves",
    },
    {
        title: "Besøk feltene lavendel og juvene",
        date: "Tor 12. oktober kl. 11:30",
        dest: "Promenade des Anglais, Nice",
        text: "Colorful Provence har noen av Frankrikes vakreste landskap, men organisering av transport for å utforske solo fra den franske riviera tar tid og krefter.",
        price: "",
        img: "https://i2.wp.com/limitless-secrets.com/wp-content/uploads/2020/05/IMG_0193.jpg?fit=819%2C1024&ssl=1",
        alt: "Lavendel fields",
    },
]

</script>
